import AuthenticationUtils from 'utils/authentication';
import Auth0ServiceInterceptor from './auth0-service-interceptor';
export const fullLogout = async ({ logout, }) => {
    // If the sub ID mismatch, log the user out
    Auth0ServiceInterceptor.resetTokenGenerator();
    // ensure monolith cookies are removed and micro-frontend cookies are added
    await AuthenticationUtils.configureLogoutCookies();
    logout({
        // encode the checkout url and pass that along as a query parameter
        returnTo: `${window.location.origin}/auth/checkout-redirect?next=${encodeURIComponent(window.location.href)}`,
    });
};
export const redirectIgnoredPaths = [
    '/auth/restricted-login',
    '/login',
    '/auth/partner-login',
    '/auth/callback',
];
